import React, { Component, Fragment } from "react";
import { Button, Icon, Tag, Result, Modal } from "antd";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import DEFINE, { PATHS } from "../../../../../../constants/Define";
import * as Func from "../../../../../../helpers/functions";
import {
  PageListComponent,
  HeaderListComponent,
  ListComponent,
  FilterDropdown,
} from "../../../../common/component/Index";
import Ripple from "../../../../common/component/Ripple";
import { FlagIcons } from "../../../../common/component/TranslateButton";
import Wrapper from "containers/backend/common/component/Wrapper";
import Span from "containers/backend/common/component/Span";
import AntSelect, {
  AntOption,
} from "containers/backend/common/component/AntSelect";

let permisionActions = {};
const pageSize = 10;

export default class ProductList extends Component {
  state = {
    filters: {
      PageIndex: 1,
      PageSize: pageSize,
    },
    propertyId: null,
  };

  componentDidMount() {
    permisionActions = Func.getPermissionActions(
      DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT,
    );

    if (!permisionActions || !permisionActions.allowView) {
      return;
    }
    this.props.getProperties();
    this.props.getProducts(this.state.filters);
  }

  buildFilters = (pagination, filters, sorter) => {
    const currentFilters = this.state.filters || {};
    const hasNameKey = Object.prototype.hasOwnProperty.call(
      filters || {},
      "name",
    );
    const hasShortNameKey = Object.prototype.hasOwnProperty.call(
      filters || {},
      "shortName",
    );
    const hasCodeKey = Object.prototype.hasOwnProperty.call(
      filters || {},
      "code",
    );
    const hasStatusKey = Object.prototype.hasOwnProperty.call(
      filters || {},
      "isActive",
    );
    const nameFilterRaw = filters?.name;
    const shortNameFilterRaw = filters?.shortName;
    const codeFilterRaw = filters?.code;
    const statusFilterRaw = filters?.isActive;
    const nameFilter = Array.isArray(nameFilterRaw)
      ? nameFilterRaw[0]
      : undefined;
    const shortNameFilter = Array.isArray(shortNameFilterRaw)
      ? shortNameFilterRaw[0]
      : undefined;
    const codeFilter = Array.isArray(codeFilterRaw)
      ? codeFilterRaw[0]
      : undefined;
    const statusFilter = Array.isArray(statusFilterRaw)
      ? statusFilterRaw[0]
      : undefined;
    const nameEmpty =
      typeof nameFilter === "string" && nameFilter.trim() === "";
    const shortNameEmpty =
      typeof shortNameFilter === "string" && shortNameFilter.trim() === "";
    const codeEmpty =
      typeof codeFilter === "string" && codeFilter.trim() === "";
    const nameCleared =
      (hasNameKey &&
        Array.isArray(nameFilterRaw) &&
        nameFilterRaw.length === 0) ||
      nameEmpty;
    const shortNameCleared =
      (hasShortNameKey &&
        Array.isArray(shortNameFilterRaw) &&
        shortNameFilterRaw.length === 0) ||
      shortNameEmpty;
    const codeCleared =
      (hasCodeKey &&
        Array.isArray(codeFilterRaw) &&
        codeFilterRaw.length === 0) ||
      codeEmpty;
    const statusCleared =
      hasStatusKey &&
      Array.isArray(statusFilterRaw) &&
      statusFilterRaw.length === 0;
    const searchTerm =
      nameCleared || codeCleared || shortNameCleared
        ? undefined
        : nameFilter !== undefined && !nameEmpty
          ? nameFilter
          : codeFilter !== undefined && !codeEmpty
            ? codeFilter
            : shortNameFilter !== undefined && !shortNameEmpty
              ? shortNameFilter
              : currentFilters.SearchTerm;
    const isActive = statusCleared
      ? undefined
      : statusFilter !== undefined
        ? statusFilter
        : currentFilters.IsActive;
    const orderBy = sorter?.order ? sorter.field : undefined;
    const orderByDesc = sorter?.order ? sorter.order === "descend" : undefined;
    const pageIndex = pagination?.current || currentFilters.PageIndex || 1;
    const pageSizeValue =
      pagination?.pageSize || currentFilters.PageSize || pageSize;
    const changedFilters =
      searchTerm !== currentFilters.SearchTerm ||
      isActive !== currentFilters.IsActive ||
      orderBy !== currentFilters.OrderBy ||
      orderByDesc !== currentFilters.OrderByDesc;
    const nextFilters = Func.removeObjectNull({
      PageIndex: changedFilters ? 1 : pageIndex,
      PageSize: pageSizeValue,
      SearchTerm: searchTerm,
      IsActive: isActive,
      PropertyId: this.state.propertyId,
      OrderBy: orderBy,
      OrderByDesc: orderByDesc,
    });
    return nextFilters;
  };

  handleChange = (pagination, filters, sorter) => {
    const nextFilters = this.buildFilters(pagination, filters, sorter);
    this.setState({ filters: nextFilters });
    this.props.getProducts(nextFilters);
  };

  formatOutlets = (outlets, record) => {
    const outletList = Array.isArray(outlets) ? outlets : [];
    const names = outletList
      .map((outlet) => outlet?.name || outlet?.code || outlet?.id)
      .filter(Boolean);
    if (names.length) {
      return names.join(", ");
    }
    return record?.fnbOutletId || record?.outletId || record?.outlet || "";
  };

  onSync = () => {
    const { t } = this.props;
    Modal.confirm({
      title: t("action.sync"),
      content:
        t("notification.confirmSyncProductFnb") ||
        "Bạn có chắc chắn muốn đồng bộ dữ liệu?",
      okText: t("action.confirm") || "Xác nhận",
      cancelText: t("action.cancel") || "Hủy",
      onOk: () => {
        this.props.syncProducts({
          propertyId: this.state.propertyId,
        });
      },
    });
  };

  selectFilterSearch = (input, option) => {
    const optionText = Func.vietnameseStringToUnicode(
      (option?.props?.children || "")?.toString().toLowerCase(),
    );
    const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };

  onChangeProperty = (value) => {
    const nextFilters = Func.removeObjectNull({
      ...this.state.filters,
      PageIndex: 1,
      PropertyId: value ?? null,
    });
    this.setState({ filters: nextFilters, propertyId: value ?? null });
    this.props.getProducts(nextFilters);
  };

  render() {
    const { t, fnbState } = this.props;
    const { products, loading, productSyncing, productPagination, error } =
      fnbState;
    const { filters, propertyId } = this.state;
    const { properties } = this.props;

    if (!permisionActions || !permisionActions.allowView) {
      return (
        <Result
          status="403"
          title="403"
          subTitle={
            t("item.fnb.menu.unauthorized") ||
            "Bạn không có quyền truy cập vào khu vực này"
          }
        />
      );
    }

    // Hiển thị error nếu API trả về lỗi 403 (backend permission check failed)
    if (error && error.status === 403) {
      return (
        <Result
          status="403"
          title="403"
          subTitle="Backend API trả về 403. Vui lòng kiểm tra permission ở backend hoặc liên hệ quản trị viên."
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              Tải lại trang
            </Button>
          }
        />
      );
    }

    const canSync = permisionActions && permisionActions.allowSync && propertyId;
    const columns = [
      {
        title: t("item.fnb.product.code"),
        dataIndex: "code",
        key: "code",
        sorter: true,
      },
      {
        title: t("item.fnb.product.name"),
        dataIndex: "name",
        key: "name",
        sorter: true,
        filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <FilterDropdown
            setSelectedKeys={setSelectedKeys}
            selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters}
          />
        ),
        filterIcon: (filtered) => (
          <Icon
            type="search"
            style={{ color: filtered ? "#1890ff" : undefined }}
          />
        ),
        render: (text, record) => text,
      },
      {
        title: t("item.fnb.product.shortName"),
        dataIndex: "shortName",
        key: "shortName",
        sorter: true,
        filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <FilterDropdown
            setSelectedKeys={setSelectedKeys}
            selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters}
          />
        ),
        filterIcon: (filtered) => (
          <Icon
            type="search"
            style={{ color: filtered ? "#1890ff" : undefined }}
          />
        ),
      },
      {
        title: t("item.fnb.product.translations"),
        dataIndex: "translations",
        key: "translations",
        render: (translations) => <FlagIcons languages={translations || []} />,
      },
      {
        title: t("item.fnb.product.status"),
        dataIndex: "isActive",
        key: "isActive",
        filters: [
          { value: true, text: t("item.fnb.product.active") },
          { value: false, text: t("item.fnb.product.inactive") },
        ],
        filterMultiple: false,
        filteredValue:
          filters.IsActive !== undefined ? [filters.IsActive] : null,
        render: (isActive, record) => {
          const active =
            typeof isActive === "boolean" ? isActive : Boolean(record.status);
          return active ? (
            <Tag color="green">{t("item.fnb.menu.active")}</Tag>
          ) : (
            <Tag color="red">{t("item.fnb.menu.inactive")}</Tag>
          );
        },
      },
      {
        title: t("action.action"),
        key: "action",
        align: "right",
        render: (text, record) => (
          <Link
            to={Func.getPathWithParams(PATHS.FNB.PRODUCT.DETAIL.path, {
              id: record.id,
            })}
          >
            <Icon type="form" className="fs20 colorPrimary" />
          </Link>
        ),
      },
    ];

    return (
      <Fragment>
        <PageListComponent>
          <HeaderListComponent
            path={this.props.match.path}
            titleHeader={t("navigation.fnbProduct")}
            extraBreadcrumbs={[{ title: t("navigation.fnbProduct") }]}
            componentRight={
              <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                <Button
                  icon="sync"
                  className="btn btn-primary"
                  disabled={!canSync}
                  onClick={this.onSync}
                >
                  {t("action.sync")}
                </Button>
              </Ripple>
            }
          />
          <Wrapper
            className="row col-md-12 p-2"
            style={{ marginBottom: "1rem" }}
          >
            <Wrapper className="col-md-4">
              <Span>{t("item.property.title") || "Property"}:</Span>
              <AntSelect
                className="select-departure"
                showArrow
                showSearch
                allowClear
                placeholder={t("item.property.title") || "Property"}
                value={propertyId}
                onChange={this.onChangeProperty}
                style={{ width: "100%" }}
                filterOption={this.selectFilterSearch}
              >
                <AntOption value={null}>Tất cả</AntOption>
                {(properties || []).map((property) => (
                  <AntOption key={property.id} value={property.id}>
                    {property.name || property.code || property.id}
                  </AntOption>
                ))}
              </AntSelect>
            </Wrapper>
          </Wrapper>
          <ListComponent
            tableKey="menu-list"
            classChildren="p-0"
            classParent="m-0"
            rowKey={(record, index) => record.id || index}
            loading={{ spinning: loading, size: "large" }}
            dataSource={products || []}
            columns={columns}
            onChange={this.handleChange}
            pagination={{
              total: productPagination?.totalCount || 0,
              totalPage: productPagination?.totalPage || 0,
              defaultCurrent: productPagination?.pageIndex || 1,
              defaultPageSize: productPagination?.pageSize || pageSize,
            }}
          />
        </PageListComponent>
      </Fragment>
    );
  }
}
